import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const FilterSetDeleteModal = ({ isOpen, option, onConfirm, onClose }) => {
  const handleConfirm = () => {
    if (!option) return;
    onConfirm?.({ id: option.value });
    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} modalClassName="filters-set-save-modal">
      <ModalHeader toggle={onClose}>Delete Filter Set</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ color: 'black', fontWeight: '500' }} className="main-header pt-2">
          Are you sure you want to delete "{option?.label || 'this filter set'}"?
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button style={{color: 'white'}} color="danger" onClick={handleConfirm}>Delete</Button>
      </ModalFooter>
    </Modal>
  );
};

export default FilterSetDeleteModal;
